module.exports = __webpack_public_path__ + "img/ico_menual01_on.8b971953.svg";